import React from 'react';
import './Skeleton.css';

const Skeleton = ({ style }) => {
  return <div className="fuel-skeleton" style={style}></div>;
};

export default Skeleton;
